import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import AuthInnerNavbar from "src/components/navbar/authInnerNavbar";
import { LOGOUT } from "../helper/constants";
import { useDispatch } from "react-redux";
import { logout as logoutAction } from "src/store/authSlice";


const ManagerDashboard = lazy(
  () => import("src/screens/innerScreens/manager_dashboard/managerDashboard")
);

const KeySettingScreen = lazy(
  () => import("src/screens/innerScreens/key_setting/keySettingScreen")
);

const MessageSettingScreen = lazy(
  () => import("src/screens/innerScreens/message_setting/messageSettingScreen")
);

const ChangePasswordScreen = lazy(
  () => import("src/screens/innerScreens/profile_change_password/profileChangePasswordScreen")
);

const SmsSettingScreen = lazy(
  () => import("src/screens/innerScreens/sms_setting/smsSettingScreen")
);

const PGSettingScreen = lazy(
  () => import("src/screens/innerScreens/profile_payment_gateway_setting/profilePaymentGatewaySettingScreen")
);

const ProfileScreen = lazy(
  () => import("src/screens/innerScreens/profile/profileScreen")
);

const ProfileGeneralScreen = lazy(
  () => import("src/screens/innerScreens/profile_general/profileGeneralScreen")
);

const ProfileMyProfileScreen = lazy(
  () => import("src/screens/innerScreens/profile_my_profile/profileMyProfileScreen")
);

const ProfileEditMyProfileScreen = lazy(
  () => import("src/screens/innerScreens/profile_my_profile/profileEditMyProfileScreen")
);

const ProfileUpdatesScreen = lazy(
  () => import("src/screens/innerScreens/profile_updates/profileUpdatesScreen")
);

const ProfileSecurityScreen = lazy(
  () => import("src/screens/innerScreens/profile_security/profileSecurityScreen")
);

const InvoiceSettingScreen = lazy(
  () => import("src/screens/innerScreens/invoice_setting/invoiceSettingScreen")
);

const ProfileBillingScreen = lazy(
  () => import("src/screens/innerScreens/profile_billing/profileBillingScreen")
);

const RegisterEmployeeScreen = lazy(
  () => import("src/screens/innerScreens/register_employee/registerEmployeeScreen")
);


const SentSMSReportScreen = lazy(
  () => import("src/screens/innerScreens/report/sent_sms_report/sentSMSReportScreen")
);


const RegisterDepartmentScreen = lazy(
  () => import("src/screens/innerScreens/register_department/registerDepartmentScreen")
);


const RegisterPaymentTypeScreen = lazy(
  () => import("src/screens/innerScreens/register_payment_type/registerPaymentTypeScreen")
);

const RegisterPaymentStatusScreen = lazy(
  () => import("src/screens/innerScreens/register_payment_status/registerPaymentStatusScreen")
);

const RegisterDesignationScreen = lazy(
  () => import("src/screens/innerScreens/register_designation/registerDesignationScreen")
);

const RegisterOfferMasterScreen = lazy(
  () => import("src/screens/innerScreens/register_offer_master/registerOfferMasterScreen")
);

const RegisterShippingMasterScreen = lazy(
  () => import("src/screens/innerScreens/register_shipping_master/registerShippingMasterScreen")
);

const RegisterPromoCodeScreen = lazy(
  () => import("src/screens/innerScreens/register_promo_code/registerPromoCodeScreen")
);

const AdminDashboardScreen = lazy(
  () => import("src/screens/innerScreens/admin_dashboard/adminDashboardScreen")
);

const RegisterProductsScreen = lazy(
  () => import("src/screens/innerScreens/register_products/registerProductsScreen")
);

const RegisterProductsCategoryScreen = lazy(
  () => import("src/screens/innerScreens/register_products_category/registerProductsCategoryScreen")
);

const RegisterProductsSubCategoryScreen = lazy(
  () => import("src/screens/innerScreens/register_products_sub_category/registerProductsSubCategoryScreen")
);

const RegisterProductDetailsScreen = lazy(
  () => import("src/screens/innerScreens/register_product_Details/registerProductDetailsScreen")
);
const ProductDetailsScreen = lazy(
  () => import("src/screens/outerScreens/productDetails/productDetailsScreen")
);

const RegisterInventoryScreen = lazy(
  () => import("src/screens/innerScreens/register_inventory/registerInventoryScreen")
);

const RegisterShippingTypeScreen = lazy(
  () => import("src/screens/innerScreens/register_shipping_type/registerShippingTypeScreen")
);

const RegisterShippingChargeScreen = lazy(
  () => import("src/screens/innerScreens/register_shipping_charge/registerShippingChargeScreen")
);

const RegisterStockStatusScreen = lazy(
  () => import("src/screens/innerScreens/register_stock_status/registerStockStatusScreen")
);

const RegisterOrderStatusScreen = lazy(
  () => import("src/screens/innerScreens/register_order_status/registerOrderStatusScreen")
);

const RegisterInventoryMasterScreen = lazy(
  () => import("src/screens/innerScreens/register_inventory_master/registerInventoryMasterScreen")
);

const RegisterSellerMasterScreen = lazy(
  () => import("src/screens/innerScreens/register_seller_master/registerSellerMasterScreen")
);

const RegisterOrderMasterScreen = lazy(
  () => import("src/screens/innerScreens/register_order_master/registerOrderMasterScreen")
);

const RegisterSuperStarScreen = lazy(
  () => import("src/screens/innerScreens/register_super_star/registerSuperStarScreen")
);

const RegisterSuperStarDetailsScreen = lazy(
  () => import("src/screens/innerScreens/register_super_star_details/registerSuperStarDetailsScreen")
);

const RegisterPromotionalPartnerScreen = lazy(
  () => import("src/screens/innerScreens/register_promotional_partner/registerPromotionalPartnerScreen")
);

const RegisterHeroCarouselScreen = lazy(
  () => import("src/screens/innerScreens/register_hero_carousel/registerHeroCarouselScreen")
);

const RegisterCarouselManagementMasterScreen = lazy(
  () => import("src/screens/innerScreens/register_carousel_management_master/registerCarouselManagementMasterScreen")
);

const RegisterBrandScreen = lazy(
  () => import("src/screens/innerScreens/register_brand/registerBrandScreen")
);

const RegisterAudienceScreen = lazy(
  () => import("src/screens/innerScreens/register_audience/registerAudienceScreen")
);

const RegisterVariantSizeScreen = lazy(
  () => import("src/screens/innerScreens/register_variant_size/registerVariantSizeScreen")
);

const RegisterVariantColorScreen = lazy(
  () => import("src/screens/innerScreens/register_variant_color/registerVariantColorScreen")
);

const RegisterSwiperCarouselScreen = lazy(
  () => import("src/screens/innerScreens/register_swiper_carousel/registerSwiperCarouselScreen")
);

const RegisterWarehouseScreen = lazy(
  () => import("src/screens/innerScreens/register_warehouse/registerWarehouseScreen")
);

const ProductReportScreen = lazy(
  () => import("src/screens/innerScreens/report/product_report/productReportScreen")
);

const InventoryReportScreen = lazy(
  () => import("src/screens/innerScreens/report/inventory_report/inventoryReportScreen")
);

const OfferReportScreen = lazy(
  () => import("src/screens/innerScreens/report/offer_report/offerReportScreen")
);

const OrdersScreen = lazy(
  () => import("src/screens/innerScreens/orders/ordersScreen")
);

const ProductsScreen = lazy(
  () => import("src/screens/innerScreens/products/productsScreen")
);

const RegisterPaymentMasterScreen = lazy(
  () => import("src/screens/innerScreens/register_payment_master/registerPaymentMasterScreen")
);

const RegisterCategoryCarouselScreen = lazy(
  () => import("src/screens/innerScreens/register_category_carousel/registerCategoryCarouselScreen")
);

const RegisterSellerScreen = lazy(
  () => import("src/screens/innerScreens/register_seller/registerSellerScreen")
);

const RegisterBankScreen = lazy(
  () => import("src/screens/innerScreens/register_Bank_name/registerBankNameScreen")
);


// const WishListScreen = lazy(
//   () => import("src/screens/innerScreens/wishList/wishListScreen")
// );

const MainRoute: React.FC = () => {
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(logoutAction());
    LOGOUT();
  };

  return (
    <AuthInnerNavbar>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/ManagerDashboard" element={<ManagerDashboard />} />
          <Route path="/Logout" element={<LogoutComponent onLogout={handleLogout} />} />
          <Route path="/Profile" element={<ProfileScreen />} />
          <Route path="/KeySetting" element={<KeySettingScreen />} />
          <Route path="/MessageSetting" element={<MessageSettingScreen />} />
          <Route path="/SmsSetting" element={<SmsSettingScreen />} />
          <Route path="/PGSettingScreen" element={<PGSettingScreen />} />
          <Route path="/ProfileGeneral" element={<ProfileGeneralScreen />} />
          <Route path="/ChangePassword" element={<ChangePasswordScreen />} />
          <Route path="/MyProfile" element={<ProfileMyProfileScreen IsUserProfileUploaded={false} />} />
          <Route path="/ProfileUpdates" element={<ProfileUpdatesScreen />} />
          <Route path="/ProfileSecurity" element={<ProfileSecurityScreen />} />
          <Route path="/InvoiceSetting" element={<InvoiceSettingScreen />} />
          <Route path="/ProfileBilling" element={<ProfileBillingScreen />} />
          <Route path="/EditMyProfile" element={<ProfileEditMyProfileScreen />} />
          <Route path="/RegisterEmployee" element={<RegisterEmployeeScreen />} />

          <Route path="/SentSMSReport" element={<SentSMSReportScreen />} />
          <Route path="/RegisterDepartment" element={<RegisterDepartmentScreen />} />


          {/* <Route path="/Quotation" element={<QuotationScreen UserID={0} result={undefined} />} /> */}
          <Route path="/RegisterDesignation" element={<RegisterDesignationScreen />} />
          <Route path="/RegisterOfferMaster" element={<RegisterOfferMasterScreen />} />
          <Route path="/RegisterShippingMaster" element={<RegisterShippingMasterScreen />} />
          <Route path="/RegisterPromoCode" element={<RegisterPromoCodeScreen />} />
          <Route path="/AdminDashboard" element={<AdminDashboardScreen />} />
          <Route path="/RegisterProducts" element={<RegisterProductsScreen />} />
          <Route path="/RegisterProductsCategory" element={<RegisterProductsCategoryScreen />} />
          <Route path="/RegisterProductsSubCategory" element={<RegisterProductsSubCategoryScreen />} />
          <Route path="/RegisterProductDetails" element={<RegisterProductDetailsScreen />} />
          <Route path="/ProductDetails" element={<ProductDetailsScreen />} />
          <Route path="/RegisterInventory" element={<RegisterInventoryScreen />} />
          <Route path="/RegisterShippingType" element={<RegisterShippingTypeScreen />} />
          <Route path="/RegisterShippingCharge" element={<RegisterShippingChargeScreen />} />
          {/* <Route path="/WishList" element={<WishListScreen />} /> */}

          <Route path="/RegisterStockStatus" element={<RegisterStockStatusScreen />} />
          <Route path="/RegisterOrderStatus" element={<RegisterOrderStatusScreen />} />
          <Route path="/RegisterInventoryMaster" element={<RegisterInventoryMasterScreen />} />
          <Route path="/RegisterSellerMaster" element={<RegisterSellerMasterScreen />} />
          <Route path="/RegisterOrderMaster" element={<RegisterOrderMasterScreen />} />
          <Route path="/RegisterSuperStar" element={<RegisterSuperStarScreen />} />
          <Route path="/RegisterSuperStarDetails" element={<RegisterSuperStarDetailsScreen />} />
          <Route path="/RegisterPromotionalPartner" element={<RegisterPromotionalPartnerScreen />} />
          <Route path="/RegisterHeroCarousel" element={<RegisterHeroCarouselScreen />} />
          <Route path="/RegisterCarouselManagement" element={<RegisterCarouselManagementMasterScreen />} />
          <Route path="/RegisterBrand" element={<RegisterBrandScreen />} />
          <Route path="/RegisterAudience" element={<RegisterAudienceScreen />} />
          <Route path="/RegisterVariantSize" element={<RegisterVariantSizeScreen />} />
          <Route path="/RegisterVariantColor" element={<RegisterVariantColorScreen />} />
          <Route path="/RegisterSwiperCarousel" element={<RegisterSwiperCarouselScreen />} />
          <Route path="/RegisterWarehouse" element={<RegisterWarehouseScreen />} />
          <Route path="/ProductReport" element={<ProductReportScreen />} />
          <Route path="/InventoryReport" element={<InventoryReportScreen />} />
          <Route path="/OfferReport" element={<OfferReportScreen />} />
          <Route path="/Orders" element={<OrdersScreen />} />
          <Route path="/Products" element={<ProductsScreen />} />
          <Route path="/RegisterPayment" element={<RegisterPaymentMasterScreen />} />
          <Route path="/RegisterCategoryCarousel" element={<RegisterCategoryCarouselScreen />} />
          <Route path="/RegisterSeller" element={<RegisterSellerScreen />} />
          <Route path="/RegisterBank" element={<RegisterBankScreen />} />
        </Routes>
      </Suspense>
    </AuthInnerNavbar>
  );
};

export default MainRoute;

interface LogoutComponentProps {
  onLogout: () => void;
}

const LogoutComponent: React.FC<LogoutComponentProps> = ({ onLogout }) => {
  React.useEffect(() => {
    onLogout();
  }, [onLogout]);

  return <div>Logging out...</div>;
};
